// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Entsorger, EntsorgerDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useUpdateEntsorger(): (
  entsorgerId: string,
  requestBody: EntsorgerDaten
) => Promise<Entsorger> {
  const getAPI = useGetApi();
  return useCallback(
    async (entsorgerId, requestBody) =>
      (await getAPI()).entsorger.updateEntsorger({ entsorgerId, requestBody }),
    [getAPI]
  );
}
